let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <wmsOrderCode>WMS订单号, string (50), 必填</wmsOrderCode>
    <expressCompany>快递公司代码, string (50), 必填</expressCompany>
    <expressCode>快递单号, string (50), 必填</expressCode>
    <transferCode>转运单号, string (50)，快递以旧换新业务场景中用于退货单号</transferCode>
    <opCode>路由状态, 例如: collect=揽件、confirm=调度确认、load=已装车、 despatch=已发运、arrive=已到达、sign=已签收、reject=派送失败, 必填</opCode>
    <acceptTime>路由时间, string (19), YYYY-MM-DD HH:MM:SS, 必填</acceptTime>
    <address>路由发生地点, string (300)</address>
    <remark>路由信息, string (500)</remark>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default {
  xmlRequest,
  xmlResponse
}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.routing.receive.js